import http from "./httpService";
import { apiUrl } from "../config";

export const getCdkFieldPreferences = () => {
  return http.get(`${apiUrl}CdkFieldPreference/GetCdkFieldPreferences`);
};

export const updateCdkFieldPreferences = (preferences) => {
  return http.put(
    `${apiUrl}CdkFieldPreference/UpdateCdkFieldPreferences`,
    preferences
  );
};

export const getDefaultFieldOrder = () => {
  return http.get(`${apiUrl}CdkFieldPreference/GetDefaultFieldOrder`);
};

export const getCDKShipViaDefault = () =>
  http.get(`${apiUrl}CdkFieldPreference/GetFilters`);

export const postNewCDKShipViaDefault = (newData) =>
  http.post(`${apiUrl}CdkFieldPreference/PostFilters`, newData);

export const updateCDKShipViaDefault = (newData) =>
  http.post(`${apiUrl}CdkFieldPreference/UpdateFilters`, newData);

export const getCDKUniqueShipVia = (filterName = "") =>
  http.get(`${apiUrl}CdkFieldPreference/GetFilterByName`, {
    params: {
      name: filterName,
    },
  });
